import React, { useState, useEffect } from "react";
import aside from "../Images/Login-img.png";
import "./CSS/ForgotPassword.css";
import GlobalInput from "../components/CustomInputForgot";
import { validateEmail, validatePassword } from "../Utils/Validation";
import CustomButton from "../components/CustomButtonForgot";
import { useNavigate } from "react-router-dom";
import { READ_ONE_EVENT, UPDATE_PASSWORD } from "../Api/apiConstant";
import { useGetAPIWithoutTokenQuery, usePostAPIMutation } from "../Api/api";
import { toast, ToastContainer } from "react-toastify";
import { useLocation } from "react-router-dom";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import { useThemeColors } from "../Context/Theme";
import encryptJSON from "../ServiceModule/Encrypt";
import { isProdEnv, secretEncryptionKey } from "../ServiceModule/Service";

function UpdatePassword() {
  const navigate = useNavigate();
  const eventName = sessionStorage.getItem("eventName");
  const [updatePassword, setUpdatePassword] = useState({
    password: "",
    confirmPassword: "",
  });
  const location = useLocation();
  const [Email, setEmail] = useState("");
  const [post, { isSuccess }] = usePostAPIMutation();
  const [isValidPassword, setIsValidPassword] = useState(true);
  const [hasUpperCase, setHasUpperCase] = useState(false);
  const [hasLowerCase, setHasLowerCase] = useState(false);
  const [hasNumber, setHasNumber] = useState(false);
  const [hasSpecialChar, setHasSpecialChar] = useState(false);
  const [isValidLength, setIsValidLength] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordCheck, setShowPasswordCheck] = useState(false);
  const eventId = sessionStorage.getItem("event_id");

  const handleUpdatePassword = async (e) => {
    e.preventDefault();
    try {
      let payloadData = {
        user_email: location?.state?.email.toLowerCase(),
        user_password: updatePassword?.confirmPassword
      }
      if (isProdEnv == "true") {
        const encryptedPayload = encryptJSON(payloadData, secretEncryptionKey);
        payloadData = {
          element: encryptedPayload,
        }
      }
      if (updatePassword.password === updatePassword.confirmPassword) {
        const { data } = await post({
          url: UPDATE_PASSWORD,
          formData: payloadData,
        });

        toast.success('Password updated successfully');
        setTimeout(() => {
          navigate(`/events/${eventName}/login`);
        }, 2000);
      } else {
        toast.error('Passwords do not match');
      }
    } catch (error) {

    }
  };

  const handlePassword = (e) => {
    const newPassword = e.target.value;

    // Remove spaces from the input
    const sanitizedPassword = newPassword.replace(/\s/g, "");
    setUpdatePassword({ ...updatePassword, password: sanitizedPassword });

    // Password validations
    const hasUpperCase = /[A-Z]/.test(sanitizedPassword);
    const hasLowerCase = /[a-z]/.test(sanitizedPassword);
    const hasNumber = /[0-9]/.test(sanitizedPassword);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(sanitizedPassword);
    const isValidLength = sanitizedPassword.length >= 8 && sanitizedPassword.length <= 64;

    // Update state for individual checks
    setHasUpperCase(hasUpperCase);
    setHasLowerCase(hasLowerCase);
    setHasNumber(hasNumber);
    setHasSpecialChar(hasSpecialChar);
    setIsValidLength(isValidLength);

    // Compute overall password validity
    const isValidPassword =
      hasLowerCase && hasUpperCase && hasNumber && hasSpecialChar && isValidLength;
    setIsValidPassword(isValidPassword);
  };

  const handleConfirmPassword = (e) => {
    setUpdatePassword({ ...updatePassword, confirmPassword: e.target.value });
  };

  const { data, isError } = useGetAPIWithoutTokenQuery(
    `${READ_ONE_EVENT}${eventId}`
  );

  const theme = useThemeColors();

  return (
    <React.Fragment>
      <ToastContainer autoClose={2000} />
      <section class="overflow-hidden">
        <div class="container-fluid">
          <div class="row vh-100">
            <div class="col-sm-6 px-0 py-0 m-0 d-none d-sm-block position-relative">
              <div
                style={{
                  position: "relative",
                  width: "100%",
                  height: "100vh",
                }}
              >
                <img
                  src={data?.event_img_path ? data?.event_img_path : aside}
                  alt="Login image"
                  className="w-100 vh-100"
                  style={{
                    objectFit: "cover",
                    objectPosition: "left",
                    margin: "0",
                    overflow: "hidden",
                  }}
                />
                <div
                  style={{
                    position: "absolute",
                    top: "0",
                    left: "0",
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(0, 0, 0, 0.7)",
                  }}
                ></div>
              </div>

              <div class="overlay-content" style={{ width: "100%" }}>
                <img
                  src={theme.logo}
                  alt="Logo"
                  class="logo"
                  width={218}
                  className="mb-5"
                />
                <p
                  style={{ fontSize: "30px", fontWeight: "700", width: "100%" }}
                  class="heading"
                >
                  Welcome to ORDER THAT
                </p>
                <p
                  style={{
                    fontSize: "19px",
                    fontWeight: "500",
                    textAlign: "center",
                  }}
                >
                  You're Tailgate Ready with Order That
                </p>
              </div>
            </div>
            <div class="col-sm-6 text-black">
              <div class="d-flex justify-content-center align-items-center h-custom-2 px-5 ms-xl-4  pt-5 pt-xl-0 mt-xl-n5">
                <form
                  style={{
                    width: "50rem",
                    height: "32rem",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "flex-start",
                    borderRadius: "16px",
                    padding: "3em",
                    paddiingLeft: "1.5em",
                  }}
                >
                  <div
                    style={{
                      width: "20vw",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                    }}
                  >
                    <p class="login-text  fw-bold">Reset Password</p>
                  </div>
                  <div style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "flex-start",
                    gap: "0.5em"
                  }}>
                    <div
                      data-mdb-input-init
                      class="form-outline"

                    >
                      <GlobalInput
                        type={showPassword ? "text" : "password"}
                        label="Enter new password"
                        value={updatePassword.password}
                        onChange={handlePassword}
                        placeholder="Enter your Password"
                        className={!isValidPassword ? "is-invalid" : ""}
                        style={{
                          borderColor: !isValidPassword ? "red !important" : "",
                        }}
                        required
                        width={"25vw"}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            handleUpdatePassword(e);
                          }
                        }}
                        endIcon={
                          showPassword ? (
                            <RemoveRedEyeOutlinedIcon
                              onClick={() => setShowPassword(!showPassword)}
                              style={{ cursor: "pointer", color: "grey" }}
                            />
                          ) : (
                            <VisibilityOffOutlinedIcon
                              onClick={() => setShowPassword(!showPassword)}
                              style={{ cursor: "pointer", color: "grey" }}
                            />
                          )
                        }
                      />
                      {updatePassword.password && !(hasUpperCase && hasLowerCase && hasNumber && hasSpecialChar && isValidLength) && (
                        <p className="text-secondary mt-2">
                          <ul style={{ paddingLeft: "15px", marginBottom: "0px !important" }}>
                            <li style={{
                              fontSize: "12px"
                            }} className={hasUpperCase ? "text-success" : "text-danger"}>
                              At least one uppercase letter
                            </li>
                            <li style={{
                              fontSize: "12px"
                            }} className={hasLowerCase ? "text-success" : "text-danger"}>
                              At least one lowercase letter
                            </li>
                            <li style={{
                              fontSize: "12px"
                            }} className={hasNumber ? "text-success" : "text-danger"}>
                              At least one number
                            </li>
                            <li style={{
                              fontSize: "12px"
                            }} className={hasSpecialChar ? "text-success" : "text-danger"}>
                              At least one special character
                            </li>
                            <li style={{
                              fontSize: "12px"
                            }} className={isValidLength ? "text-success" : "text-danger"}>
                              Between 8-64 characters
                            </li>
                          </ul>
                        </p>
                      )}
                    </div>
                    <div
                      data-mdb-input-init
                      class="form-outline mb-3"
                      style={{ height: "10vh" }}
                    >
                      <GlobalInput
                        type={showPasswordCheck ? "text" : "password"}
                        label="Confirm password"
                        value={updatePassword.confirmPassword}
                        onChange={handleConfirmPassword}
                        placeholder="Enter your Password"
                        required
                        width={"25vw"}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            handleUpdatePassword(e);
                          }
                        }}
                        endIcon={
                          showPasswordCheck ? (
                            <RemoveRedEyeOutlinedIcon
                              onClick={() => setShowPasswordCheck(!showPasswordCheck)}
                              style={{ cursor: "pointer", color: "grey" }}
                            />
                          ) : (
                            <VisibilityOffOutlinedIcon
                              onClick={() => setShowPasswordCheck(!showPasswordCheck)}
                              style={{ cursor: "pointer", color: "grey" }}
                            />
                          )
                        }
                      />
                    </div>
                    <div class="" style={{ width: "25vw" }}>
                      <CustomButton
                        text="Password Reset"
                        size="lg"
                        block={true}
                        onClick={handleUpdatePassword}
                        className="mt-2"
                        btnStyle={{}}
                        width={"25vw"}
                        disabled={!validatePassword(updatePassword.password) || updatePassword.password !== updatePassword.confirmPassword}
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
}

export default UpdatePassword;
